var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "order-detail", attrs: { "data-cy": "order-detail" } },
    [
      _c("div", { staticClass: "order-detail__header" }, [
        _c(
          "button",
          {
            staticClass: "order-detail__back-button btn-link",
            attrs: { "data-cy": "order-detail-back" },
            on: { click: _vm.onBack }
          },
          [
            _c("i", { staticClass: "fa fa-arrow-left" }),
            _vm._v(" \n      "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "BACK",
                  expression: "'BACK'"
                }
              ],
              staticClass: "order-detail__back-label text-uppercase"
            })
          ]
        ),
        _vm._v(" "),
        !_vm.statusPending
          ? _c("span", { staticClass: "timestamp" }, [
              _vm._v(_vm._s(_vm.getDate(_vm.order.startTime)))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.statusPending
        ? _c("div", [
            _c("h3", { staticClass: "order-detail__title" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("ORDER")) +
                  " " +
                  _vm._s(_vm.order.id) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "order-detail__body" }, [
              _c("p", [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("ORDER_STATUS")) + " \n        "
                ),
                _c(
                  "span",
                  {
                    staticClass: "order-detail__status",
                    class: _vm.orderStatusColor
                  },
                  [_vm._v(_vm._s(_vm.orderStatus))]
                )
              ]),
              _vm._v(" "),
              _vm.order.errorMessage
                ? _c("p", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("ORDER_ERROR_MESSAGE")) +
                        " " +
                        _vm._s(_vm.order.errorMessage) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("ORDER_COUNTRY")) +
                    " " +
                    _vm._s(_vm.order.assigmentSettings.countryCode)
                )
              ]),
              _vm._v(" "),
              _vm.order.assigmentSettings.areaCode
                ? _c("p", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("ORDER_AREA_CODE")) +
                        " " +
                        _vm._s(_vm.order.assigmentSettings.areaCode) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.order.affiliateId
                ? _c("p", [
                    _vm._v(
                      " \n        " +
                        _vm._s(_vm.$t("ORDER_PUBLISHER")) +
                        "                     \n        "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "table-ellipsis__name linked-name",
                        attrs: {
                          rel: "noopener",
                          target: "_blank",
                          href: "javascript:;"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.gotToPublisher(_vm.order.affiliateId)
                          }
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "display-text",
                            attrs: { title: _vm.order.publisher.name }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.order.publisher.name) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("ORDER_NUMBER_TYPE")) +
                    " " +
                    _vm._s(
                      _vm.order.assigmentSettings.isTollFree
                        ? _vm.$t("NUMBER_TF")
                        : _vm.$t("NUMBER_DID")
                    )
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("ORDER_AMOUNT")) +
                    " " +
                    _vm._s(_vm.order.requestAmount)
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("ORDER_CHARGE")) +
                    " " +
                    _vm._s(_vm.$t(_vm.order.chargeAccountToFill ? "YES" : "NO"))
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("ORDER_ALLOCATED")) +
                    " " +
                    _vm._s(_vm.order.completedAmount)
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-right p-t-5" }, [
              !_vm.order.completed
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      attrs: { "data-cy": "order-detail-cancel" },
                      on: { click: _vm.cancelOrder }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("ORDER_CANCEL")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.statusPending
        ? _c(
            "div",
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "ORDER_LOADING",
                    expression: "'ORDER_LOADING'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }